var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_22913)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8675 26.1328C10.846 26.1328 4.13227 31.7322 2.42172 39.2355C1.95584 41.2791 3.69916 43.0003 5.79518 43.0003H31.9398C34.0358 43.0003 35.7791 41.2791 35.3132 39.2355C33.6027 31.7322 26.889 26.1328 18.8675 26.1328Z",
    fill: "#8FCAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8C14.0294 8 10 12.9593 10 19.0769V21.1538L19 23.2308L28 21.1538V19.0769C28 12.9593 23.9706 8 19 8Z",
    fill: "#8FCAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8268 23.2317C21.9812 23.2317 24.5383 20.1321 24.5383 16.3086H13.1152C13.1152 20.1321 15.6724 23.2317 18.8268 23.2317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4696 15.2695C24.5148 15.6232 24.5383 15.9858 24.5383 16.355C24.5383 20.2088 21.9812 23.3329 18.8268 23.3329C15.6724 23.3329 13.1152 20.2088 13.1152 16.355C13.1152 15.9858 13.1387 15.6232 13.1839 15.2695",
    stroke: "#3C4657",
    strokeWidth: 1.03846,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_22913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleAvatar);
export default __webpack_public_path__ + "static/media/FemaleAvatar.e745fd614173af119e3864a914b56a41.svg";
export { ForwardRef as ReactComponent };